/** Estrae messaggio leggibile da errori supabase.functions.invoke */
export async function getEdgeFunctionErrorMessage(
  error: unknown,
  data: unknown,
): Promise<string> {
  // FunctionsHttpError espone il body in context (Response)
  if (error && typeof error === "object" && "context" in error) {
    const ctx = (error as { context?: unknown }).context;
    if (ctx instanceof Response) {
      try {
        const body = await ctx.clone().json();
        if (body && typeof body === "object" && "error" in body && body.error) {
          return String(body.error);
        }
      } catch {
        // ignore parse failure
      }
    }
  }

  if (data && typeof data === "object" && "error" in data && (data as { error: unknown }).error) {
    return String((data as { error: unknown }).error);
  }

  if (error instanceof Error) return error.message;
  return "Errore sconosciuto";
}
